import { Attachment } from '@sdk/attachments/types';
import LightboxGallery from '@sdk/components/ui/LightboxGallery/LightboxGallery';
import { SingleAttachmentPreview } from '@sdk/attachments/components/SingleAttachmentPreview';

import { escapeAttachmentUrl } from '@web/common/utils/escapeAttachmentUrl';

import { usePreview } from './attachmentsPreview.hooks';
import { AttachmentContainer, AttachmentsWrapper } from './attachmentsPreview.styles';

type Props = {
  attachments: Attachment[];
};

export const AttachmentsPreview = ({ attachments }: Props) => {
  const escapedAttachments = escapeAttachmentUrl(attachments);
  const { isGalleryOpen, closeGallery, currentImageUrl, images, openAttachment } = usePreview({
    attachments: escapedAttachments,
  });

  return (
    <>
      <AttachmentsWrapper>
        {escapedAttachments.map((attachment) => (
          <AttachmentContainer onClick={() => openAttachment(attachment)} key={attachment.id}>
            <SingleAttachmentPreview attachment={attachment} />
          </AttachmentContainer>
        ))}
      </AttachmentsWrapper>

      {!!images.length && (
        <LightboxGallery
          isOpen={isGalleryOpen}
          onClose={closeGallery}
          images={images}
          openUrl={currentImageUrl}
        />
      )}
    </>
  );
};
